import './App.css'
import {
  createBrowserRouter,
  RouterProvider,
  Route,
  createRoutesFromElements,
} from 'react-router-dom'

import { AuthProvider } from './contexts/AuthContext'
import Sidebar from './pages/dealdashboard/sidebar'
import Dashboard from './pages/dealdashboard/dashboard'
import PreSeed from './pages/dealdashboard/preSeed'
import Blog from './pages/dealdashboard/blog'
import Seed from './pages/dealdashboard/seed'
import Growth from './pages/dealdashboard/growth'
import Ma from './pages/dealdashboard/ma'
import Ipo from './pages/dealdashboard/ipo'
import World from './pages/dealdashboard/world'
import SliderTable from './pages/dealdashboard/sliderTable'
import TrendingNews from './pages/dealdashboard/trendingNews'
import LatestDeal from './pages/dealdashboard/LatestDeal'
import Funding from './pages/dealdashboard/funding'
import FundingReport from './pages/dealdashboard/fundingReport'
import Financial from './pages/dealdashboard/financial'
import FinancialReport from './pages/dealdashboard/financialReport'
import Customise from './pages/dealdashboard/customise'
import Sample from './pages/dealdashboard/sample'
import AddSlider from './pages/dealdashboard/addSlider'
import AddTrendingNews from './pages/dealdashboard/addtrendingNews'
import NotFound from './pages/notFound'
import AddLatestDeal from './pages/dealdashboard/addLatestDeal'
import AddFundingReport from './pages/dealdashboard/addFundingReport'
import AddFinancialReport from './pages/dealdashboard/addFinancialReport'
import LoginForm from './pages/dealdashboard/LoginForm'
import ProtectedRoute from './components/ProtectedRoute'
import AddPreseed from './pages/dealdashboard/AddPreseed'
import AddBlog from './pages/dealdashboard/AddBlog'
import AddSeed from './pages/dealdashboard/AddSeed'
import AddGrowth from './pages/dealdashboard/AddGrowth'
import AddMa from './pages/dealdashboard/AddMa'
import AddIpo from './pages/dealdashboard/AddIpo'
import AddWorld from './pages/dealdashboard/AddWorld'
import EditBanner from './pages/dealdashboard/EditBanner'
import AddCustomise from './pages/dealdashboard/AddCustomise'
import AddSample from './pages/dealdashboard/AddSample'
import Admin from './pages/dealdashboard/Admin'
import AddAdmin from './pages/dealdashboard/AddAdmin'
import AddPermission from './pages/dealdashboard/AddPermission'
import EditCompany from './components/EditCompany'
import EditFinancialReport from './pages/dealdashboard/EditFinancialReport'
import EditFundingCompany from './pages/dealdashboard/EditFundingCompany'
import EditFinancialCompany from './pages/dealdashboard/EditFinancialCompany'
import User from './pages/dealdashboard/User'
import Graph from './pages/dealdashboard/Graph'
import AddGraph from './pages/dealdashboard/AddGraph'
import BulkAddGraph from './pages/dealdashboard/BulkAddGraph'
import UserActivity from './pages/dealdashboard/UserActivity'
import Invoice from './components/Invoice'
import Order from './components/Order'
import CreatePdf from './components/CreatePdf'
import PaymentStatus from './components/PaymentStatus'
import Message from './pages/dealdashboard/Message'
import Founder from './pages/dealdashboard/Founder'
import Investor from './pages/dealdashboard/Investor'
import EditFounder from './pages/dealdashboard/EditFounder'
import ListCompany from './pages/ListCompany'
import Cart from './pages/dealdashboard/Cart'

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      {/* Public Routes */}
      <Route path="/login" element={<LoginForm />} />

      {/* Redirect root to dealdashboard */}
      <Route
        path="/"
        element={<ProtectedRoute redirectTo="/dealdashboard" />}
      />

      {/* Admin Routes */}
      <Route element={<ProtectedRoute />}>
        <Route path="/dealdashboard" element={<Sidebar />}>
          <Route index element={<Dashboard />} />
          <Route path="preseed" element={<PreSeed />} />
          <Route path="blog" element={<Blog />} />
          <Route path="seed" element={<Seed />} />
          <Route path="growth" element={<Growth />} />
          <Route path="ma" element={<Ma />} />
          <Route path="ipo" element={<Ipo />} />
          <Route path="world" element={<World />} />
          <Route path="slider" element={<SliderTable />} />
          <Route path="news" element={<TrendingNews />} />
          <Route path="latestDeal" element={<LatestDeal />} />

          <Route path="funding" element={<Funding />} />
          <Route path="funding/report/:id" element={<FundingReport />} />

          <Route path="financial" element={<Financial />} />
          <Route path="financial/:id" element={<FinancialReport />} />

          <Route path="customise" element={<Customise />} />
          <Route path="contactus" element={<Message />} />
          <Route path="founder" element={<Founder />} />
          <Route path="investor" element={<Investor />} />
          <Route path="sample" element={<Sample />} />
          <Route path="admin" element={<Admin />} />
          <Route path="graph" element={<Graph />} />

          {/* Add routes */}
          <Route path="founder/list/company/:id" element={<ListCompany />} />
          <Route path="founder/update/:id" element={<EditFounder />} />
          <Route path="add/slider/:id?" element={<AddSlider />} />
          <Route path="add/trending/:id?" element={<AddTrendingNews />} />
          <Route path="add/customise/:id?" element={<AddCustomise />} />
          <Route path="add/preseed/:id?" element={<AddPreseed />} />
          <Route path="add/blog/:id?" element={<AddBlog />} />
          <Route path="add/seed/:id?" element={<AddSeed />} />
          <Route path="add/growth/:id?" element={<AddGrowth />} />
          <Route path="add/ma/:id?" element={<AddMa />} />
          <Route path="add/ipo/:id?" element={<AddIpo />} />
          <Route path="add/world/:id?" element={<AddWorld />} />
          <Route path="edit/banner/:id?" element={<EditBanner />} />
          <Route path="add/latestdeal/:id?" element={<AddLatestDeal />} />
          <Route path="add/graph/:id?" element={<AddGraph />} />
          <Route path="add/graph-bulk" element={<BulkAddGraph />} />
          <Route
            path="add/funding/:companyId?/:id?"
            element={<AddFundingReport />}
          />
          <Route
            path="edit/funding/:companyId?/:id?"
            element={<AddFundingReport />}
          />
          <Route path="add/financial/:id?" element={<AddFinancialReport />} />
          <Route path="add/sample/:id?" element={<AddSample />} />
          <Route path="add/admin" element={<AddAdmin />} />
          <Route path="add/admin/:id" element={<AddPermission />} />
          <Route path="edit/company/:id" element={<EditCompany />} />
          <Route
            path="financial/edit/company/:id"
            element={<EditFinancialCompany />}
          />
          <Route
            path="funding/edit/company/:id"
            element={<EditFundingCompany />}
          />
          <Route
            path="edit/financial/:id/:reportId"
            element={<EditFinancialReport />}
          />

          {/* Payment status routes - referenced in sidebar but missing in router */}
          <Route path="payment-status" element={<PaymentStatus />} />
          <Route path="product-delivered" element={<Order />} />
          <Route path="invoice" element={<Invoice />} />

          <Route path="pdf" element={<CreatePdf />} />

          {/* User management routes - referenced in sidebar but missing in router */}
          <Route path="users" element={<User />} />
          <Route path="user-activity" element={<UserActivity />} />
          <Route path="user/cart" element={<Cart />} />
        </Route>
      </Route>

      {/* 404 Route */}
      <Route path="*" element={<NotFound />} />
    </>
  )
)

function App() {
  return (
    <AuthProvider>
      <div className="app">
        <RouterProvider router={router} />
      </div>
    </AuthProvider>
  )
}

export default App
